import { Method } from '../../packages/neb-api-client/src/utils/api-client-utils';
import ApiClientV2 from '../../packages/neb-api-client/src/utils/api-client-v2';

export const apiClient = new ApiClientV2({ microservice: 'core' });

export const getAuditShieldDashboard = async (
  tenantId,
  optOutLoadingIndicator = false,
) => {
  const { data } = await apiClient.makeRequest({
    optOutLoadingIndicator,
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/audit-shield',
    replacements: { tenantId },
    headers: { 'Content-Type': 'application/json' },
  });

  return data[0];
};
